import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import '../../../css/financeiro-parcela-pagar.css';

export default function PainelPlanoConta() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({});
    const [planoContas, setPlanoContas] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    const buscar = () => {
        setBuscando(true);
        api({ method: 'get', action: '/financeiroPlanoConta', token: token, params: filtro })
            .then(response => {
                setPlanoContas(response.data.data);
                setBuscando(false);
                setPage(1);
            })
            .catch(() => { setBuscando(false); });
    };

    useEffect(() => {
        document.querySelector("#nome") && document.querySelector("#nome").focus();
        buscar();
    },
    // eslint-disable-next-line
    []);

    const total = planoContas.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = planoContas.slice((page - 1) * pageSize, page * pageSize);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Plano de Contas</h1></div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroPlanoConta" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Nova Conta
                        </Link>
                    </div>
                </div>

                <form className="fin-pp__card fin-pp__search" style={{ marginBottom: 16, padding: '12px 16px' }} onSubmit={e => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            id="nome"
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome da conta"
                            onChange={e => setFiltro({ ...filtro, nome: e.target.value })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 60 }}></th>
                                    <th style={{ width: 95 }}>Situação</th>
                                    <th style={{ width: 100 }}>Tipo</th>
                                    <th style={{ width: 100 }}>Código</th>
                                    <th>Nome</th>
                                    <th>Superior</th>
                                    <th>Grupo DRE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando
                                    ? <tr><td colSpan={7} className="fin-pp__empty">Buscando...</td></tr>
                                    : paginados.length === 0
                                        ? <tr><td colSpan={7} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    {row.bancoDados && (
                                                        <Link to={"/cadastroPlanoConta/" + row.id} className="fin-pp__rowbtn">
                                                            <FaPen size={14} />
                                                        </Link>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className={'fin-pp__pill ' + (row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted')}>
                                                        {row.situacaoRegistro}
                                                    </span>
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.tipo === 1 ? 'Analítica' : 'Sintética'}
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.caminho != null ? row.caminho : ''}</td>
                                                <td>
                                                    {row.tipo === 2
                                                        ? <strong className="fin-pp__cell-strong">{row.nome}</strong>
                                                        : <span className="fin-pp__cell-muted">{row.nome}</span>
                                                    }
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.superior
                                                        ? <strong>{row.superior.caminho + ' - ' + row.superior.nome}</strong>
                                                        : ''
                                                    }
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.grupodre
                                                        ? (row.grupodre.operacao === 1 ? '(+) ' : '(-) ') + row.grupodre.nome
                                                        : ''
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
